import React from "react";
import LinearProgress from '@mui/material/LinearProgress';
import { i18n } from '../../translate/i18n';

const PhotoBarUploading = ({ photo }) => {

  return (
    <div style={{display: 'flex', flexDirection: 'row'}}>
        {photo.length > 0 && photo[0] && !photo[0].uploaded && photo[0].preview && !photo[0].error && photo[0].progress && (
            <div>
            {i18n.t('divPhotoUp.load')}
            <LinearProgress variant="determinate" value={photo[0].progress} />
            </div>
        )}
    </div>
  );
};

export default PhotoBarUploading;
